export default __webpack_public_path__ + "static/media/mony.3e10d98e.svg";